<template>
    <el-container :style="ApplicationHomeClass()" class="ComplaintProposalPraiseAccount" v-loading.fullscreen.lock="fullscreenLoading">
        <el-header height="auto">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="合计方式">
                    <el-select v-model="form.show_type" placeholder="请选择">
                        <el-option label="周" value="week"></el-option>
                        <el-option label="月" value="month"></el-option>
                        <el-option label="季度" value="season"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="年" class="year">
                    <el-date-picker
                        v-model="form.iYear"
                        type="year"
                        value-format="yyyy"
                        placeholder="选择年">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="创建日期" class="createdate">
                    <el-date-picker
                        v-model="form.createdate"
                        type="datetimerange"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                    <!-- <el-button type="primary" @click="ExportRMAsurface" style="margin-left: 10px !important;">导出</el-button> -->
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <div class="centent">
                <div id="centent" ref="centent"></div>
            </div>
        </el-main>
    </el-container>
</template>

<script>
/*eslint-disable */
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
export default {
    name: "ComplaintProposalPraiseAccount",
    data() {
        return {
            http: https.http,
            visible: false,
            fullscreenLoading: false,
            centent: [],
            centents: [],
            form: {
                iYear: '2023',
                show_type: 'month',
                createdate: []
            },
            currentPage: 1,
            Size: 20,
            total: 0,
            title: []
        };
    },
    mounted() {
        let that = this
        // this.$refs.main.$el.style.height = `calc(100% - ${this.$refs.height.$el.offsetHeight}px)`
        window.addEventListener('resize', () => {
            if (this.$refs.centent) {
                this.Echarts(this.$refs.centent, 'centent')
            }
        })
    },
    watch: {},
    methods: {
        Echarts (e, name) {
            let that = this
            var myChart = this.$echarts.init(e)
            // console.log(e, e.clientWidth, e.clientWidth - 12)
            myChart.resize({
                width: e.clientWidth - 12,
                height: e.clientHeight - 1
            })
            var option
            let header = []
            let data = [[], [], []]
            let sum
            let color = ['#5b9bd5', '#ed7d31','#ffc000', '#a5a5a5' ]
            let olddata = JSON.parse(JSON.stringify(this[name]))
            for (let item in this.centent) {
                header.push(JSON.parse(JSON.stringify(this.centent[item].date)))
            }
            for (let item in this.centent) {
                data[0].push(JSON.parse(JSON.stringify(this.centent[item].tousu)))
            }
            for (let item in this.centent) {
                data[1].push(JSON.parse(JSON.stringify(this.centent[item].jianyi)))
            }
            for (let item in this.centent) {
                data[2].push(JSON.parse(JSON.stringify(this.centent[item].total)))
            }
            let sumData = JSON.parse(JSON.stringify(data[2]))
            sumData.sort(function (a, b) {
                return a - b
            })
            sum = Number(sumData[sumData.length - 1]) + 1
            let title = ['投诉', '建议', '总计']
            option = {
                color: color,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                toolbox: {
                    // feature: {
                    //     myEnlarge: {
                    //         show: true,
                    //         title: '放大',
                    //         icon: 'path://M465.454545 907.636364a442.181818 442.181818 0 1 1 0-884.363637 442.181818 442.181818 0 0 1 0 884.363637z m0-46.545455a395.636364 395.636364 0 1 0 0-791.272727 395.636364 395.636364 0 0 0 0 791.272727z M761.437091 794.344727a23.272727 23.272727 0 1 1 32.907636-32.907636l197.213091 197.213091a23.272727 23.272727 0 0 1-32.907636 32.907636l-197.213091-197.213091zM279.272727 488.727273a23.272727 23.272727 0 1 1 0-46.545455h372.363637a23.272727 23.272727 0 1 1 0 46.545455H279.272727z M442.181818 279.272727a23.272727 23.272727 0 0 1 46.545455 0v372.363637a23.272727 23.272727 0 1 1-46.545455 0V279.272727z',
                    //         onclick: function () {
                    //             that.EnlargeTrue = true
                    //             that.key = name
                    //             that.title = 'RMA'
                    //             if (name === 'center') {
                    //                 that.title = ''
                    //             }
                    //         }
                    //     }
                    // }
                },
                legend: {
                    data: title
                },
                xAxis: [
                    {
                        type: 'category',
                        data: header,
                        axisPointer: {
                        type: 'shadow'
                        },
                            axisLabel: {
                            interval: 0,
                            rotate: 40
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        max: sum,
                        minInterval: 1
                    }
                ],
                series: [
                    {
                        name: title[0],
                        type: 'bar',
                        barMaxWidth: 50,
                        data: data[0]
                    },
                    {
                        name: title[1],
                        type: 'bar',
                        barMaxWidth: 50,
                        data: data[1]
                    },
                    {
                        name: title[2],
                        type: 'bar',
                        barMaxWidth: 50,
                        data: data[2]
                    }
                ]
            }
            option && myChart.setOption(option)
        },
        ApplicationHomeClass () {
            // 应用样式
            return { height: this.Height - 105 + 'px' }
        },
        onSubmit () {
            this.fullscreenLoading = true;
            this.getReportAccountList();
        },
        getReportAccountList () {
            let form = JSON.parse(JSON.stringify(this.form));
            let data = {
                iYear: form.iYear,
                show_type: form.show_type,
                createdate: form.createdate[0],
                createdate1: form.createdate[1]
            };
            data.ADMIN_ID = getAdminId();
            data.ADMIN_TOKEN = getToken();
            this.title = []
            this.$store.dispatch('ShowComplaintProposalPraiseAccountList', data).then(res => {
                this.fullscreenLoading = false;
                this.centent = JSON.parse(JSON.stringify(res.data))
                // this.centents = JSON.parse(JSON.stringify(res.something))
                // // for (let item in res.something) {
                // //     this.title.push(item)
                // // }
                // // this.title = res.something
                this.Echarts(this.$refs.centent, 'centent')
            });
        }
    },
    created() {
        this.fullscreenLoading = true;
        this.getReportAccountList();
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    },
    components: {}
};
</script>

<style>
.ComplaintProposalPraiseAccount .el-header {
    /* padding-right: 0px !important; */
    padding: 0px 15px !important;
    line-height: 40px;
}
.ComplaintProposalPraiseAccount .el-header .el-form-item {
    margin-bottom: 0px;
}
.ComplaintProposalPraiseAccount .el-header .el-form-item .el-form-item__label {
    vertical-align: top;
    margin: 0px;
}
.ComplaintProposalPraiseAccount .el-header .el-form-item .el-select .el-input .el-input__suffix {
    line-height: 30px;
}
.ComplaintProposalPraiseAccount .el-header .el-form-item .el-date-editor {
    height: 30px;
    line-height: 30px;
}
/* .ComplaintProposalPraiseAccount .el-header .el-form-item .el-date-editor .el-input__icon {
    line-height: 30px;
} */
.ComplaintProposalPraiseAccount .el-header .el-form-item.year .el-date-editor .el-input__icon {
    line-height: 30px;
}
.ComplaintProposalPraiseAccount .el-header .el-form-item.createdate .el-date-editor input {
    height: 27px;
}
.ComplaintProposalPraiseAccount .el-header .el-form-item .el-date-editor input {
    height: 30px;
}
.ComplaintProposalPraiseAccount .el-header .el-form-item .el-date-editor .el-range__icon {
    line-height: 23px;
}
.ComplaintProposalPraiseAccount .el-header .el-form-item .el-date-editor .el-range-separator {
    line-height: 23px;
    padding: 0px;
}
.ComplaintProposalPraiseAccount .el-header .el-form-item input {
    height: 30px;
}
.ComplaintProposalPraiseAccount .el-header .el-form-item .el-button {
    padding-top: 8px;
    padding-bottom: 8px;
}
.ComplaintProposalPraiseAccount .el-main .centent {
    height: 100%;
    min-height: 300px;
}
.ComplaintProposalPraiseAccount .el-main #centent {
    height: 100%;
}
</style>
